<template>
  <div>
    <div class="page_title">商城平台券</div>

    <div class="discountsList">
      <div class="container">
        <div class="searchbox">
          <div>优惠券名称：</div>
          <el-input
            v-model="keywords"
            style="width: 180px; margin: 0 10px"
            clearable
          />
          <div>创建时间：</div>
          <el-date-picker
            v-model="dateList"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 225px; margin-left: 10px"
            @change="onepage"
          ></el-date-picker>
          <el-button
            @click="onepage"
            type="info"
            style="background-color: #eceff2; color: #747981; margin-left: 10px"
            >查询</el-button
          >
        </div>
        <div class="searchbox">
          <el-button
            type="primary"
            @click="toAddDiscount"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('378') : false
            "
            >添加优惠券</el-button
          >
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column label="排序" prop="sort" width="120">
              <template slot-scope="scope">
                <el-input-number
                  v-model="scope.row.sort"
                  step-strictly
                  :step="1"
                  :min="0"
                  :max="9999999999"
                  :controls="false"
                  style="width: 80px"
                  @change="setSort(scope.row.coupon_data_id, scope.row.sort)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('379')
                      : false
                  "
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column
              label="优惠券名称"
              width="300"
              prop="coupon_name"
            ></el-table-column>
            <el-table-column
              label="创建时间"
              prop="create_time"
            ></el-table-column>
            <el-table-column label="使用条件">
              <template slot-scope="scope"
                >满{{ scope.row.money }}减{{ scope.row.enough }}元</template
              >
            </el-table-column>

            <el-table-column
              prop="give_total"
              label="已发放数量"
            ></el-table-column>
            <el-table-column
              prop="off_total"
              label="已使用数量"
            ></el-table-column>
            <el-table-column prop="total" label="剩余发放数"></el-table-column>
            <el-table-column label="操作" width="180">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="medium"
                  @click="toEditDiscount(scope.row.coupon_data_id)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('380')
                      : false
                  "
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  size="medium"
                  @click="toGiveDiscount(scope.row.coupon_data_id)"
                  v-if="scope.row.coupon_status == 1"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('384')
                      : false
                  "
                  >发放</el-button
                >
                <el-button
                  type="text"
                  size="medium"
                  @click="updateCouponStatus(scope.row)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('381')
                      : false
                  "
                >
                  <span v-if="scope.row.coupon_status == 1" class="red"
                    >禁用</span
                  >
                  <span v-else>启用</span>
                </el-button>
                <el-button
                  type="text"
                  size="medium"
                  @click="setCouponDataRegisterGive(scope.row)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('385')
                      : false
                  "
                >
                  <!-- <span v-if="scope.row.register_give == 1" class="red"
                    >取消赠送新用户</span
                  >
                  <span v-else>自动赠送新用户</span> -->
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="text-align: center">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            style="margin: 20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
export default {
  data() {
    return {
      total: 0,
      page: 1,
      pageNumber: 10,
      tableData: [],
      keywords: "",
      dateList: null,
    };
  },

  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.getList();
  },
  methods: {
    // 充值搜索page
    onepage() {
      this.page = 1;
      this.getList();
    },
    getList() {
      this.tableData = [];
      let create_time_start = "";
      let create_time_end = "";
      if (this.dateList) {
        create_time_start = dayjs(this.dateList[0]).format("YYYY-MM-DD");
        create_time_end = dayjs(this.dateList[1]).format("YYYY-MM-DD");
      }
      console.log("this.dateList", this.dateList);
      let data = {
        page: this.page,
        pageNumber: this.pageNumber,
        keywords: this.keywords,
        create_time_start: create_time_start,
        create_time_end: create_time_end,
      };
      console.log("date", data);
      this.axios.post("platform/shop/getCouponDataList", data).then((res) => {
        this.total = res.data.total;
        let list = res.data.list;
        list.forEach((ele) => {
          ele.create_time = dayjs
            .unix(ele.create_time)
            .format("YYYY-MM-DD HH:mm");
          ele.total = ele.total == -1 ? "无限" : ele.total;
        });
        this.tableData = list;
      });
    },

    handleSizeChange(pageNumber) {
      this.pageNumber = pageNumber;
      this.getList();
    },
    handleCurrentChange(size) {
      this.page = size;
      this.getList();
    },
    toAddDiscount() {
      this.$router.push("./addDiscount");
    },
    //修改排序
    setSort(coupon_data_id, sort) {
      let data = {
        coupon_data_id,
        sort,
      };
      this.axios
        .post("platform/shop/updateCouponDataSort", data)
        .then((res) => {
          this.$message.success("修改成功");
          this.getList();
        })
        .catch((err) => {
          console.log(err);
          this.getList();
        });
    },

    //修改状态
    updateCouponStatus(item) {
      let data = {
        coupon_data_id: item.coupon_data_id,
        coupon_status: item.coupon_status == 1 ? 0 : 1,
      };
      this.axios
        .post("platform/shop/updateCouponDataStatus", data)
        .then((res) => {
          this.getList();
          this.$message.success("修改成功");
        });
    },
    //设置优惠券是否赠送注册用户
    setCouponDataRegisterGive(item) {
      let data = {
        coupon_data_id: item.coupon_data_id,
        register_give: item.register_give == 1 ? 0 : 1,
      };
      this.axios
        .post("platform/shop/setCouponDataRegisterGive", data)
        .then((res) => {
          this.getList();
          this.$message.success("修改成功");
        });
    },
    toGiveDiscount(coupon_data_id) {
      this.$router.push({
        path: "./giveDiscount",
        query: {
          coupon_data_id,
        },
      });
    },
    toEditDiscount(coupon_data_id) {
      this.$router.push({
        path: "./editDiscount",
        query: {
          coupon_data_id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.discountsList {
  text-align: left;
  padding: 20px;
  border-radius: 5px;
}
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  padding: 20px;
}
</style>
